/*
  COTANTIN — 比較スライダー（VID 適用 実装指示書 v1.16 §3.4.9）
  snippets/cotantin-compare.liquid が出す <cotantin-compare> を動かす。
  境界の位置は CSS 変数 --pos（％）だけで表す。見た目は assets/cotantin-lp.css。

  - ハンドルの横ドラッグだけを拾う（Pointer Events）。写真の上で縦にスクロールしてもページが動く
  - 写真のどこかをタップすると、そこまで境界が寄る
  - 画面に入ったとき 1 度だけ 開始位置 → −15% → 開始位置 と 900ms で動かす
    （prefers-reduced-motion のときはやらない）
  - ハンドルは role="slider"。←→ で 5% ずつ、Home／End で端まで
*/
(function () {
  if (window.customElements && customElements.get('cotantin-compare')) return;
  if (!window.customElements) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v) { return Math.max(0, Math.min(100, v)); }

  class CotantinCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.stage = this.querySelector('.ct-compare__stage');
      this.handle = this.querySelector('.ct-compare__handle');
      if (!this.stage || !this.handle) return;
      this.start = clamp(parseFloat(this.dataset.start) || 50);
      this.set(this.start);

      this.handle.addEventListener('pointerdown', this.onDown.bind(this));
      this.handle.addEventListener('keydown', this.onKey.bind(this));
      this.stage.addEventListener('click', this.onClick.bind(this));

      if (!reduce && 'IntersectionObserver' in window) {
        var self = this;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            self.hint();
          });
        }, { threshold: 0.6 });
        io.observe(this.stage);
      }
    }

    set(pos) {
      this.pos = clamp(pos);
      this.style.setProperty('--pos', this.pos + '%');
      this.handle.setAttribute('aria-valuenow', String(Math.round(this.pos)));
    }

    posFromEvent(e) {
      var r = this.stage.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    }

    onDown(e) {
      e.preventDefault();
      this.stopHint();
      this.dragging = true;
      this.moved = false;
      try { this.handle.setPointerCapture(e.pointerId); } catch (err) { /* 古いブラウザ */ }
      var self = this;
      var move = function (ev) { self.moved = true; self.set(self.posFromEvent(ev)); };
      var up = function () {
        self.dragging = false;
        self.handle.removeEventListener('pointermove', move);
        self.handle.removeEventListener('pointerup', up);
        self.handle.removeEventListener('pointercancel', up);
      };
      this.handle.addEventListener('pointermove', move);
      this.handle.addEventListener('pointerup', up);
      this.handle.addEventListener('pointercancel', up);
    }

    onClick(e) {
      // ハンドルを動かした直後の click は無視する（離した位置に飛ばないように）
      if (this.handle.contains(e.target)) return;
      this.stopHint();
      this.animateTo(this.posFromEvent(e), 250);
    }

    onKey(e) {
      var step = { ArrowLeft: -5, ArrowRight: 5 }[e.key];
      if (step) { e.preventDefault(); this.stopHint(); this.set(this.pos + step); return; }
      if (e.key === 'Home') { e.preventDefault(); this.set(0); }
      if (e.key === 'End') { e.preventDefault(); this.set(100); }
    }

    animateTo(target, duration, done) {
      var from = this.pos;
      var t0 = null;
      var self = this;
      if (reduce) { this.set(target); if (done) done(); return; }
      cancelAnimationFrame(this.raf);
      var tick = function (t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / duration);
        var ease = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        self.set(from + (target - from) * ease);
        if (k < 1) self.raf = requestAnimationFrame(tick);
        else if (done) done();
      };
      this.raf = requestAnimationFrame(tick);
    }

    hint() {
      if (this.dragging) return;
      var self = this;
      this.hinting = true;
      this.animateTo(this.start - 15, 450, function () {
        if (!self.hinting) return;
        self.animateTo(self.start, 450, function () { self.hinting = false; });
      });
    }

    stopHint() {
      if (!this.hinting) return;
      this.hinting = false;
      cancelAnimationFrame(this.raf);
    }
  }

  customElements.define('cotantin-compare', CotantinCompare);
})();
